var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 409.6,
    height: 307.2,
    viewBox: "0 0 409.6 307.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off",
    transform: "translate(0 -51.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2853",
    "data-name": "Group 2853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2852",
    "data-name": "Group 2852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9397",
    "data-name": "Path 9397",
    d: "M358.4,75.338,334.269,51.2,295.987,89.49A208.074,208.074,0,0,0,204.8,68.268c-87.567,0-163.835,55-204.8,136.535,20.137,40.084,48.886,73.585,83.236,97.449L51.205,334.267,75.341,358.4l38.216-38.216,44.252-44.237h-.015ZM119.47,204.8A85.329,85.329,0,0,1,204.8,119.468a84.456,84.456,0,0,1,46.931,14.269l-24.986,24.98a50.908,50.908,0,0,0-68.034,68.034l-24.98,24.986A84.565,84.565,0,0,1,119.47,204.8Z",
    fill: "#383c3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2855",
    "data-name": "Group 2855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2854",
    "data-name": "Group 2854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9398",
    "data-name": "Path 9398",
    d: "M353.121,128.888l-64.164,64.164a85.842,85.842,0,0,1,1.183,11.75A85.329,85.329,0,0,1,204.8,290.137a85.351,85.351,0,0,1-11.743-1.183L148.6,333.421a206.39,206.39,0,0,0,56.2,7.921c87.567,0,163.835-54.984,204.8-136.535a268.134,268.134,0,0,0-56.479-75.919Z",
    fill: "#383c3a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.1205ceb4dfa028e232c9dd9e37a2e0b8.svg";
export { ForwardRef as ReactComponent };